import React, { useState } from 'react'
import {
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'
import { Close as CloseIcon, Search as SearchIcon } from '@material-ui/icons'
import { styles } from '../styles/js/headerSearch'
import { withStyles } from '@material-ui/core/styles'

const HeaderSearchComponent = ({
  classes,
  setDialogSearch,
  setDialogShare,
  searchParams,
  searchState,
  setSearchState,
  clearSearch,
  search,
  estabelecimentosCategorias,
}) => {
  const [scrollAbove, setScrollAbove] = useState(false)

  window.addEventListener('scroll', function (event) {
    if (this.scrollY >= 450 && !scrollAbove) {
      setScrollAbove(true)
    }

    if (this.scrollY < 450 && scrollAbove) {
      setScrollAbove(false)
    }
  })

  const handleChange = (event) => {
    setSearchState({ ...searchState, [event.target.name]: event.target.value })
  }

  const handleSearch = () => {
    search(searchState)
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <Grid
      container
      alignItems='center'
      className={
        classes.root + (scrollAbove ? ' ' + classes.greyBackground : '')
      }
      spacing={1}
    >
      <Grid item xs={6} sm={4} md={2}>
        <Paper onKeyPress={handleKeyPress} className={classes.paper}>
          <TextField
            name={'cidade'}
            value={searchState.cidade}
            onChange={handleChange}
            placeholder={'Cidade'}
            fullWidth
            InputProps={{ disableUnderline: true }}
            InputLabelProps={{ disableAnimation: true }}
          />
        </Paper>
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <Paper onKeyPress={handleKeyPress} className={classes.paper}>
          <TextField
            name={'bairro'}
            value={searchState.bairro}
            onChange={handleChange}
            placeholder={'Bairro'}
            fullWidth
            InputProps={{ disableUnderline: true }}
            InputLabelProps={{ disableAnimation: true }}
          />
        </Paper>
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Paper onKeyPress={handleKeyPress} className={classes.paper}>
          <TextField
            select
            name={'servico'}
            value={searchState.servico}
            onChange={(event) =>
              setSearchState({
                ...searchState,
                servico: event.target.value,
                servicoName: estabelecimentosCategorias.find(
                  (servico) => servico.id === event.target.value
                ).nome,
              })
            }
            fullWidth
            InputProps={{
              disableUnderline: true,
              className:
                searchState.servico === 'none' ? classes.greyLabel : '',
            }}
            InputLabelProps={{ disableAnimation: true }}
          >
            <MenuItem value='none' disabled>
              Tipo de serviço
            </MenuItem>
            {estabelecimentosCategorias.map((servico) => (
              <MenuItem key={servico.id} value={servico.id}>
                {servico.nome}
              </MenuItem>
            ))}
          </TextField>
        </Paper>
      </Grid>
      <Grid item xs={6} sm={12} md={5}>
        <Paper onKeyPress={handleKeyPress} className={classes.paper}>
          <TextField
            name={'estabelecimento'}
            value={searchState.estabelecimento}
            onChange={handleChange}
            placeholder={'Nome do estabelecimento'}
            fullWidth
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <>
                  {(searchParams.estabelecimento ||
                    searchParams.servicoName ||
                    searchParams.cidade) && (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='clearSearch'
                        onClick={clearSearch}
                      >
                        <CloseIcon color='primary' />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position='end'>
                    <IconButton aria-label='search' onClick={handleSearch}>
                      <SearchIcon color='primary' />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            }}
            InputLabelProps={{ disableAnimation: true }}
          />
        </Paper>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(HeaderSearchComponent)
